var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('menu-pae',{attrs:{"inFocus":false}},[_c('menu-processo',{attrs:{"numeroProcesso":_vm.numeroProcesso,"apensado":_vm.apensado}})],1),_c('iframe',{staticStyle:{"width":"100vw","height":"100vh"},attrs:{"src":_vm.urlVirtus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }